import {
  FINANCE_PURCHASING_INVOICE_APPROVE,
  FINANCE_PURCHASING_INVOICE_CHECK_APPROVABLE,
  FINANCE_PURCHASING_INVOICE_DISAPPROVE,
  FINANCE_PURCHASING_INVOICE_ERROR,
  FINANCE_PURCHASING_INVOICE_FETCHING_DATA,
  FINANCE_PURCHASING_INVOICE_GET_DATA,
  FINANCE_PURCHASING_INVOICE_ITEM_CREATE,
  FINANCE_PURCHASING_INVOICE_ITEM_DELETE,
  FINANCE_PURCHASING_INVOICE_ITEM_SAVE,
  FINANCE_PURCHASING_INVOICE_SAVE,
  FINANCE_PURCHASING_INVOICE_SHOW_ACCEPTED,
  FINANCE_UPDATE_LINKS
} from "../../typesAction";

const INITIAL_STATE = {
  purchasingInvoice: {
    data: null,
    isLoading: false,
    error: null,
    isApprovable: null,
    showApproved: true
  },
  links: {
    self: null,
    prev: null,
    next: null,
    first: null,
    last: null
  }
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case FINANCE_PURCHASING_INVOICE_ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        purchasingInvoice: {
          ...state.purchasingInvoice,
          error
        }
      };
    }
    case FINANCE_PURCHASING_INVOICE_FETCHING_DATA: {
      const { isLoading } = action.payload;
      return {
        ...state,
        purchasingInvoice: {
          ...state.purchasingInvoice,
          isLoading
        }
      };
    }
    case FINANCE_PURCHASING_INVOICE_GET_DATA: {
      const {
        data: {
          "hydra:member": [data]
        }
      } = action.payload;
      return {
        ...state,
        purchasingInvoice: {
          ...state.purchasingInvoice,
          data
        }
      };
    }
    case FINANCE_PURCHASING_INVOICE_CHECK_APPROVABLE: {
      const {
        data: { result: isApprovable }
      } = action.payload;

      return {
        ...state,
        purchasingInvoice: {
          ...state.purchasingInvoice,
          isApprovable
        }
      };
    }
    case FINANCE_PURCHASING_INVOICE_APPROVE:
    case FINANCE_PURCHASING_INVOICE_DISAPPROVE: {
      const { data } = action.payload;
      return {
        ...state,
        purchasingInvoice: {
          ...state.purchasingInvoice,
          data
        }
      };
    }
    case FINANCE_PURCHASING_INVOICE_SAVE: {
      const { data } = action.payload;
      return {
        ...state,
        purchasingInvoice: {
          ...state.purchasingInvoice,
          data: {
            ...state.purchasingInvoice.data,
            ...data
          }
        }
      };
    }
    case FINANCE_PURCHASING_INVOICE_ITEM_CREATE: {
      const { data } = action.payload;

      return {
        ...state,
        purchasingInvoice: {
          ...state.purchasingInvoice,
          data: {
            ...state.purchasingInvoice.data,
            purchasingInvoiceItems: [
              ...state.purchasingInvoice.data
                .purchasingInvoiceItems,
              data
            ]
          }
        }
      };
    }
    case FINANCE_PURCHASING_INVOICE_ITEM_SAVE: {
      const { data } = action.payload;
      const invoiceItemIndex = state.purchasingInvoice.data.purchasingInvoiceItems.findIndex(
        invoiceItem => invoiceItem.id === data.id
      );
      return {
        ...state,
        purchasingInvoice: {
          ...state.purchasingInvoice,
          data: {
            ...state.purchasingInvoice.data,
            purchasingInvoiceItems: [
              ...state.purchasingInvoice.data.purchasingInvoiceItems.slice(
                0,
                invoiceItemIndex
              ),
              data,
              ...state.purchasingInvoice.data.purchasingInvoiceItems.slice(
                invoiceItemIndex + 1
              )
            ]
          }
        }
      };
    }
    case FINANCE_PURCHASING_INVOICE_ITEM_DELETE: {
      const { id } = action.payload;
      const invoiceItemIndex = state.purchasingInvoice.data.purchasingInvoiceItems.findIndex(
        invoiceItem => invoiceItem.id === id
      );
      return {
        ...state,
        purchasingInvoice: {
          ...state.purchasingInvoice,
          data: {
            ...state.purchasingInvoice.data,
            purchasingInvoiceItems: [
              ...state.purchasingInvoice.data.purchasingInvoiceItems.slice(
                0,
                invoiceItemIndex
              ),
              ...state.purchasingInvoice.data.purchasingInvoiceItems.slice(
                invoiceItemIndex + 1
              )
            ]
          }
        }
      };
    }
    case FINANCE_PURCHASING_INVOICE_SHOW_ACCEPTED: {
      const { show } = action.payload;

      return {
        ...state,
        purchasingInvoice: {
          ...state.purchasingInvoice,
          showApproved: show
        }
      };

    }
    case FINANCE_UPDATE_LINKS: {
      // const {
      //     data: {
      //         "hydra:view": {
      //             "hydra:first": first,
      //             "hydra:last": last,
      //             "hydra:previous": prev,
      //             "hydra:next": next,
      //             "@id": self
      //         }
      //     }
      // } = action.payload;

      let first = null;
      let last = null;
      let prev = null;
      let next = null;
      let self = null;

      if (action.payload.data["hydra:view"]) {
        const hydra_view = action.payload.data["hydra:view"];

        first = hydra_view["hydra:first"];
        last = hydra_view["hydra:last"];
        prev = hydra_view["hydra:previous"];
        next = hydra_view["hydra:next"];
        self = hydra_view["@id"];
      }

      return {
        ...state,
        links: {
          first,
          last,
          prev,
          next,
          self
        }
      };
    }
    default:
      return state;
  }
}
